import { all } from 'redux-saga/effects';
import authSagas from '@iso/redux/auth/saga';
import usersSagas from '@iso/redux/users/saga';
import invoicesSagas from '@iso/redux/invoice/saga';
import mailSagas from '@iso/redux/mail/saga';
import denunciasSagas from '@iso/redux/denuncias/sagas';
import profileSaga from '@iso/redux/profile/saga';
import empresasSagas from '@iso/redux/empresas/saga';
import appSagas from '@iso/redux/app/saga';
import productoSagas from '@iso/redux/productos/saga';
import ventasSagas from '@iso/redux/ventas/saga';
import inventarioSagas from '@iso/redux/inventario/saga';
import opsSagas from '@iso/redux/ops/saga';
import usersRRHHSagas from '@iso/redux/RRHH/saga';
import cajaSagas from '@iso/redux/caja/saga';
import proveedorSagas from '@iso/redux/proveedores/saga';
import cotizacionesSagas from '@iso/redux/cotizaciones/saga';
import comprasSagas from '@iso/redux/compras/saga';
import notasCierreSagas from '@iso/redux/notasCierre/saga';
import downloadsSagas from '@iso/redux/downloads/saga';
import pedidosOnline from '@iso/redux/pedidosOnline/saga';
import Siigo from '@iso/redux/Siigo/saga';
import Contabilidad from '@iso/redux/contabilidad/saga';
import estadisticasSagas from '@iso/redux/estadisticas/saga';
import MovCajaAuxSagas from '@iso/redux/movCajaAux/saga';

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    usersSagas(),
    mailSagas(),
    invoicesSagas(),
    denunciasSagas(),
    profileSaga(),
    empresasSagas(),
    appSagas(),
    productoSagas(),
    ventasSagas(),
    inventarioSagas(),
    opsSagas(),
    usersRRHHSagas(),
    cajaSagas(),
    proveedorSagas(),
    cotizacionesSagas(),
    comprasSagas(),
    notasCierreSagas(),
    downloadsSagas(),
    pedidosOnline(),
    Siigo(),
    Contabilidad(),
    estadisticasSagas(),
    MovCajaAuxSagas(),
  ]);
}
